import { IconTrash } from '@tabler/icons-react'

import { AstraIcon } from '../../../../AstraIcon/AstraIcon'
import { AstraButton } from '../../../AstraButton/AstraButton'
import { TodayButton, TodayButtonProps } from './TodayButton'

export const DefaultFooter = ({ onClearClick, ...todayButtonProps }: TodayButtonProps & { onClearClick?: () => void }) => {
    if (!todayButtonProps.showTodayButton && !onClearClick) {
        return null
    }

    return (
        <div className="flex items-center gap-2">
            {todayButtonProps.showTodayButton && <TodayButton {...todayButtonProps} />}
            {onClearClick && (
                <AstraButton
                    className="justify-center"
                    fullWidth
                    variant="critical-secondary"
                    onClick={onClearClick}
                    label="Fjern"
                    icon={<AstraIcon icon={IconTrash} />}
                />
            )}
        </div>
    )
}
